import s from "./legalConsent.module.css";

/** Обязательный чекбокс согласия с произвольным текстом (ссылки внутри children). */
export default function ConsentCheckbox({
  checked,
  onChange,
  children,
  id = "legal-consent",
  disabled = false,
}) {
  return (
    <div className={s.consent}>
      <input
        id={id}
        type="checkbox"
        checked={!!checked}
        disabled={disabled}
        onChange={(e) => onChange?.(e.target.checked)}
      />
      <div
        className={s.consentText}
        onClick={(e) => {
          // Клик по ссылке — только переход, без переключения галочки.
          if (e.target.closest("a")) return;
          if (disabled) return;
          onChange?.(!checked);
        }}
      >
        {children}
      </div>
    </div>
  );
}
